import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'lib-flexible'

// 设计稿宽度（根据实际设计稿尺寸修改）
const designWidth = 1920; // 例如设计稿宽度为 1920px
const baseSize = 100; // 基准字体大小

// 设置根元素字体大小
function setRootFontSize() {
  const scale = document.documentElement.clientWidth / designWidth;
  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
  console.log(document.documentElement.clientWidth, document.documentElement.style.fontSize);
}

// 初始化
setRootFontSize();

// 监听窗口大小变化
window.addEventListener('resize', setRootFontSize);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
